<template id="menu-master-screen">
  <section>
    <b-alert
        :show="dismissCountDown"
        dismissible
        variant="Success"
        @dismissed="dismissCountDown=0">
      Record Saved Successfully
    </b-alert>
    <b-alert
        :show="dismissCountDownUpdated"
        dismissible
        variant="Warning"
        @dismissed="dismissCountDown=0">
      Record Updated Successfully
    </b-alert>
    <div class="row">
      <div class="col-md-10 col-lg-12 text-center mt-3 mb-5 ml-2">
        <div class="card">
          <div class="card-header text-left">
            <i class="fa fa-searchengin"></i>
            BusinessGlossaryConfig
            <span class="ml-5">
                            <input type="text" v-model="filterValue" placeholder="Search..." class="ml-5">
                        </span>
          </div>
          <div class="card-body">
            <!--Filters-->
            <!--table-->
            <div class="table-responsive">
              <table class="table table-bordered">
                <thead class="thead-dark">
                <tr class="text-center">
                  <th v-for="(col, index) in menuMasterHeader" v-bind:key="index">
                    {{col}}
                    <a href="#" @click="sortBy(Rcolumns[index])">
                      <i class="fa" v-bind:class="Rcolumns[index]===sortKey ? (sortOrder === 'asc' ?  'fa-sort-amount-down-alt' : 'fa-sort-amount-up-alt') : 'fa-sort' " v-bind:style="[Rcolumns[index]===sortKey ? {'color':'Gold'} : {'color':'White'}]" ></i>
                    </a>
                  </th>
                  <th>Action</th>
                </tr>
                </thead>
                <tbody>
                <template v-for="(x,idx) in filteredItems" @click="toggle(x.syspk)"
                          :class="{ opened: opened.includes(x.syspk) }">
                  <tr :value="x" v-bind:key="idx">

                    <td>
                      {{x.retailKey}}
                    </td>
                    <td style="text-align: left">
                      {{x.retailDef}}
                    </td>

                    <td class="text-center">
                      <div class="btn-group">
                        <button class="btn btn-sm btn-outline-primary" v-b-tooltip.hover
                                title="Add"
                                v-on:click="showRow(x.syspk)">
                          <i class="fa fa-plus"></i>
                        </button>
                        <button class="btn btn-sm btn-outline-warning" size="sm"
                                v-b-tooltip.hover
                                title="Edit" v-on:click="edit(x.syspk)">
                          <i class="fa fa-edit"></i>
                        </button>
                      </div>
                    </td>
                  </tr>
                  <template v-if="showInputfield && x.syspk == editableId">
                    <tr :key="x.idx"><h6>Edit Record</h6></tr>
                    <tr :key="x.idx" style="background-color: #FFF9DF;font-size: 12px">
                      <td>
                        <label>Retail Key</label>
                        <input type="text"
                               v-model="x.retailKey"
                               class="form-control" :disabled="true">
                      </td>
                      <td>
                        <label>Retail Definition</label>
                        <textarea
                               v-model="x.retailDef"
                               class="form-control" />
                      </td>

                      <td class="text-center">
                        <button class="btn btn-sm btn-outline-primary"
                                v-on:click="updateMenuMaster(x)"
                                v-b-tooltip.hover
                                title="Save">
                          <i class="fa fa-save"></i>
                        </button>
                        <button class="btn btn-sm btn-danger" v-on:click="hideR(e,x)"
                                v-b-tooltip.hover
                                title="Cancel">
                          <i class="fa fa-window-minimize"></i>
                        </button>
                      </td>
                    </tr>
                  </template>
                  <template v-if="showInput && x.syspk == savetableId">
                    <tr :key="x.idx"><h6>New Record</h6></tr>
                    <tr :key="x.idx" style="background-color: #FFF9DF;font-size: 12px">
                      <td>
                        <label>Retail Key</label>
                        <input type="text"
                               v-model="e.retailKey"
                               class="form-control">
                      </td>
                      <td>
                        <label>Retail Definition</label>
                        <input type="text"
                               v-model="e.retailDef"
                               class="form-control">
                      </td>
                      <td class="text-center">
                        <b-button v-on:click="saveMenuMaster(e)" variant="outline-primary"
                                  size="sm"
                                  v-b-tooltip.hover
                                  title="Save">
                          <i class="fa fa-save"></i>
                        </b-button>
                        <b-button v-on:click="hideR(e)" variant="outline-danger" size="sm"
                                  v-b-tooltip.hover
                                  title="Cancel">
                          <i class="fa fa-window-minimize"></i>
                        </b-button>
                      </td>
                    </tr>
                  </template>
                </template>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import axios from 'axios';
import _ from 'lodash';

export default {

  name: 'retail-dictionary-screen',
  data: function () {
    return {
      keys: [],
      sortKey: [],
      sortOrder: ['asc'],
      filterValue: '',
      menuMasterHeader: ['Retail Key', 'Retail Definition'],
      menumasterData: [],
      e: [],
      showInput: '',
      showInputfield: '',
      options: [],
      editableId: [],
      dismissSecs: 1,
      dismissCountDown: 0,
      dismissCountDownUpdated: 0,
      flag: ['True', 'False'],
      options2: [],
      opened: [],
      savetableId: [],
      hideRow: [],
    }
  },

  created: function () {
    this.loadMenumaster()
  },
  methods: {
   loadMenumaster: function () {
      let url = '/api/business-glossary-get'
      axios.get(url)
      .then(res => {
        this.menumasterData = res.data
        console.log("ALl data", this.menumasterData)
      }, err => {
        console.log('Error in fetching record', err)
      })
    },
    //Post Request
    saveMenuMaster: function (e) {
      let payload = Object.assign({}, e)
      console.log("insert business",payload)
      axios.post('/api/business-glossary-insert', payload)
          .then(response => {
            this.loadMenumaster()
            console.log('Data Updated successfully', response)
          })
          .then(this.loadMenumaster(), e => {
            console.error('error in Saving Record', e)
          })
      this.dismissCountDown = this.dismissSecs
      this.savetableId = null
    }
    ,

    //Put/Update Request
    updateMenuMaster: function (x) {
      console.log('Testing update request', this.x)
      axios.post('/api/business-glossary-update', x)
          .then(response => {
            this.loadMenumaster()
            console.log('Data Updated successfully', response)
          })
          .then(this.loadMenumaster(), e => {
            console.error('error in Updating Record', e)
          })
      this.dismissCountDownUpdated = this.dismissSecs
      this.editableId = null
    }
    ,

    //Show Edit Input Field
    edit: function (syspk, x) {
      console.log('Entered into edit function', x)
      this.showInputfield = true
      this.editableId = syspk
    },
    //Show Row
    showRow: function (syspk) {
      this.showInput = true
      this.savetableId = syspk

    }
    ,
    //High Light Selected Row
    toggle(syspk) {
      /* const index = this.opened.indexOf(id)*/
      this.opened.push(syspk)
    }
    ,
    show: function () {
      this.$modal.show('hello-world')
    }
    ,
    hide: function () {
      this.$modal.hide('hello-world')
    }
    ,

    //Hide Add record or save record
    hideR: function (syspk) {
      if (this.savetableId == syspk) {
        this.savetableId = null
        this.editableId = null
      } else {
        this.savetableId = syspk
        this.editableId = syspk
      }
    },
    sortBy: function(key) {
      console.log("The sort Key is ",key)
      if (key == this.sortKey) {
        this.sortOrder = (this.sortOrder == 'asc') ? 'desc' : 'asc';
        this.sortKey=key;
      } else {
        this.sortKey = key;
        this.sortOrder = 'asc';
      }
    }
  },//Method End

  computed: {
    "Rcolumns": function columns() {
      if (this.menumasterData.length == 0) {
        return [];
      }
      return Object.keys(this.menumasterData[0])
    },
    "orderedData": function () {
      let result=this.menumasterData;
      if (this.filterValue) {
        result = result.filter(item => item.rd2.includes(this.filterValue));
      }
      return _.orderBy(result, this.sortKey, this.sortOrder)
    },
    filteredItems() {
      let result = this.menumasterData.filter(item => {
        let keep = true;
        // This is a basic equality filter. What I did in the actual code was to have an object with filter functions for each key. If a key was missing, it defaulted to straight equality.
        this.menumasterData.forEach(key => {
          keep = keep && (this.menumasterData[key] === undefined || item[key] === this.menumasterData[key]);
        });
        return keep;
      });
      if (this.filterValue) {
        result = result.filter(item =>
            item.retailKey.toLowerCase().includes(this.filterValue.toLowerCase()) ||
            item.retailDef.toLowerCase().includes(this.filterValue.toLowerCase())

        );
      }
      return _.orderBy(result, this.sortKey, this.sortOrder)
    },
    filterDatat() {
      const filterDatat = {};
      this.menumasterData.forEach(key => {
        const vals = this.menumasterData.map(item => item[key]);
        console.log("filterDatat Data Vals",vals);
        // Cheap and efficient unique.
        filterDatat[key] = Array.from(new Set(vals));
        console.log("Distinct Options Data ",filterDatat[key]);
      });
      return filterDatat;
    }
  }
}
</script>
<style>
.opened {
  background-color: #EBEBEB;
}

.t-scroll {
  display: inline-block;
  height: 260px;
  overflow-y: scroll;
}

.font {
  /*color: #0b58a2;*/
}

.color {
  font-weight: bold;
  color: dimgrey;
}

/*Hide up/down arrowin input fields*/
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.table {
  font-size: 12px;
  text-align: left;
}

.table tr, .table td {
  height: 3px;
}

/*To Increase or Decrease Row Height change the padding value*/
.table > tbody > tr > td, .table > tbody > tr > th, .table > tfoot > tr > td, .table > tfoot > tr > th, .table > thead > tr > td, .table > thead > tr > th {
  padding: 2px;
}
</style>




